import { useField } from 'react-final-form';
import { UNAVAILABLE_RECIPIENTS_NOTE } from '../constants';
import { RecipientOption } from './types';

export const UnavailableRecipientsNote = () => {
  const {
    input: { value },
  } = useField<RecipientOption[]>('recipients', { subscription: { value: true } });

  if (!value?.some(recipient => recipient.unavailableReason)) return null;
  return <span className="oath-utility gray">{UNAVAILABLE_RECIPIENTS_NOTE}</span>;
};
